import React from "react";

function Footer() {
  return (
    <div
      className="footer py-4 d-flex flex-column flex-md-row flex-stack "
      id="kt_footer"
    >
      <div className="text-gray-900 order-2 order-md-1">
        <span className="text-muted fw-semibold me-1">2026©</span>
        <a
          href="https://astroushaa.com"
          target="_blank"
          rel="noreferrer"
          className="text-gray-800 text-hover-primary"
        >
          AstroUshaa
        </a>
      </div>
    </div>
  );
}

export default Footer;
